<app-kpi-widget
  [title]="title"
  [icon]="'ph-duotone ph-coins'"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifference]="percentageDifference"
  [costDifference]="costDifference"
  [totalCost]="totalCost"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [dropdownEnabled]="false"
  [isUptrendPositive]="false"
  [valueFormatter]="formatValue.bind(this)"
  [costFormatter]="formatCost.bind(this)"
  [costDifferenceFormatter]="formatCostDifference.bind(this)"
  [isImageIcon]="false"
></app-kpi-widget>